(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velora-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velora-cart-recommendations')) {
  customElements.define('velora-cart-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        const track = this.querySelector('.velora-cart-recs__track');
        track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth * .75, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velora-cart-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velora-checkout-sync')) {
  customElements.define('velora-checkout-sync', class extends HTMLElement {
    connectedCallback() {
      this.drawer = document.getElementById('cart-drawer');
      if (!this.drawer) return;
      this.sync = () => {
        const source = this.drawer.querySelector('[data-cart-price-holder] [data-cart-total]');
        const target = this.drawer.querySelector('[data-velora-checkout-total]');
        if (source && target && target.textContent.trim() !== source.textContent.trim()) target.textContent = source.textContent.trim();
      };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.drawer, {childList:true, subtree:true, characterData:true});
      this.sync();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velora-size-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
  let sequence = 0;
  const dialogs = new Set();
  function enhance(root) {
    const config = document.getElementById('velora-size-popup-config');
    if (!config) return;
    root.querySelectorAll('.velora-size-guide:not([data-modal-ready])').forEach(guide => {
      const details = guide.querySelector('details');
      const trigger = details?.querySelector('summary');
      const body = details?.querySelector('.velora-size-guide__body');
      if (!trigger || !body) return;
      const dialog = document.createElement('dialog');
      dialog.className = 'velora-size-modal';
      dialog.id = `velora-size-modal-${++sequence}`;
      const title = document.createElement('h2');
      title.className = 'velora-size-modal__title';
      title.id = `${dialog.id}-title`;
      title.textContent = config.dataset.title;
      dialog.setAttribute('aria-labelledby', title.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'velora-size-modal__close';
      close.setAttribute('aria-label', config.dataset.close);
      close.textContent = '×';
      dialog.append(close, title, body);
      document.body.append(dialog);
      guide.dataset.modalReady = 'true';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      details.open = false;
      let previousOverflow;
      let previousPadding;
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) return;
        previousOverflow = document.documentElement.style.overflow;
        previousPadding = document.documentElement.style.paddingRight;
        const gap = window.innerWidth - document.documentElement.clientWidth;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        if (gap > 0) document.documentElement.style.paddingRight = `${gap}px`;
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (previousOverflow !== undefined) {
          document.documentElement.style.overflow = previousOverflow;
          document.documentElement.style.paddingRight = previousPadding;
          previousOverflow = undefined;
        }
        if (trigger.isConnected) trigger.focus();
      });
      dialogs.add({dialog, guide});
    });
  }
  const init = () => enhance(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const entry of dialogs) {
      if (event.target.contains(entry.guide)) {
        if (entry.dialog.open) entry.dialog.close();
        entry.dialog.remove();
        dialogs.delete(entry);
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
